import styled from 'styled-components';
import Button from '@ux/button';
import '@ux/button/styles';

export type ShowHideButtonProps = {
  handleClick: () => void;
  text: string;
};

const StyledButton = styled(Button)`
  position: absolute;
  top: 0;

  :dir(ltr) {
    right: 1rem;
    transform: translate(0%, 40%);
  }

  :dir(rtl) {
    left: 1rem;
    transform: translate(30%, 40%);
  }
`;

const ShowHideButton = ({ handleClick, text }: ShowHideButtonProps) => {
  return <StyledButton design='inline' text={text} onClick={handleClick} />;
};

export default ShowHideButton;
